"use strict";

var _slicedToArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importStar(require("react"));
var react_error_boundary_1 = require("react-error-boundary");
var material_1 = require("@mui/material");
var mui_1 = require("tss-react/mui");
var mobx_react_1 = require("mobx-react");
var util_1 = require("../util");
var LoadingEllipses_1 = __importDefault(require("./LoadingEllipses"));
// icons
var Delete_1 = __importDefault(require("@mui/icons-material/Delete"));
var Close_1 = __importDefault(require("@mui/icons-material/Close"));
var Minimize_1 = __importDefault(require("@mui/icons-material/Minimize"));
var MoreVert_1 = __importDefault(require("@mui/icons-material/MoreVert"));
// locals
var Drawer_1 = __importDefault(require("./Drawer"));
var ErrorMessage_1 = __importDefault(require("./ErrorMessage"));
var useStyles = (0, mui_1.makeStyles)()(function (theme) {
  return {
    formControl: {
      margin: 0
    },
    spacer: {
      flexGrow: 1
    },
    drawerSelect: {
      margin: 0,
      color: theme.palette.secondary.contrastText
    },
    dropDownIcon: {
      color: theme.palette.secondary.contrastText
    },
    header: {
      background: theme.palette.secondary.main
    }
  };
});
var DrawerHeader = (0, mobx_react_1.observer)(function (_ref) {
  var session = _ref.session,
    setToolbarHeight = _ref.setToolbarHeight;
  var _ref2 = (0, util_1.getEnv)(session),
    pluginManager = _ref2.pluginManager;
  var visibleWidget = session.visibleWidget,
    activeWidgets = session.activeWidgets,
    drawerPosition = session.drawerPosition;
  var _useStyles = useStyles(),
    classes = _useStyles.classes;
  var _ref3 = (0, react_1.useState)(null),
    _ref4 = _slicedToArray(_ref3, 2),
    anchorEl = _ref4[0],
    setAnchorEl = _ref4[1];
  return react_1.default.createElement(material_1.AppBar, {
    position: "sticky",
    className: classes.header,
    ref: function ref(_ref5) {
      return setToolbarHeight((_ref5 === null || _ref5 === void 0 ? void 0 : _ref5.getBoundingClientRect().height) || 0);
    }
  }, react_1.default.createElement(material_1.Toolbar, {
    disableGutters: true
  }, react_1.default.createElement(material_1.FormControl, {
    className: classes.formControl
  }, react_1.default.createElement(material_1.Select, {
    value: visibleWidget === null || visibleWidget === void 0 ? void 0 : visibleWidget.id,
    "data-testid": "widget-drawer-selects",
    className: classes.drawerSelect,
    classes: {
      icon: classes.dropDownIcon
    },
    renderValue: function renderValue(widgetId) {
      var widget = session.activeWidgets.get(widgetId);
      if (!widget) {
        return react_1.default.createElement(material_1.Typography, {
          variant: "h6",
          color: "inherit"
        }, "Unknown widget");
      }
      var widgetType = pluginManager.getWidgetType(widget.type);
      var HeadingComponent = widgetType.HeadingComponent,
        heading = widgetType.heading;
      return HeadingComponent ? react_1.default.createElement(HeadingComponent, {
        model: widget
      }) : react_1.default.createElement(material_1.Typography, {
        variant: "h6",
        color: "inherit"
      }, heading);
    },
    onChange: function onChange(e) {
      var w = session.activeWidgets.get(e.target.value);
      if (!w) {
        session.notify("Widget not found ".concat(e.target.value), 'warning');
      } else {
        session.showWidget(w);
      }
    }
  }, Array.from(activeWidgets.values()).map(function (widget) {
    var widgetType = pluginManager.getWidgetType(widget.type);
    var HeadingComponent = widgetType.HeadingComponent,
      heading = widgetType.heading;
    return react_1.default.createElement(material_1.MenuItem, {
      "data-testid": "widget-drawer-selects-item-".concat(widget.type),
      key: widget.id,
      value: widget.id
    }, HeadingComponent ? react_1.default.createElement(HeadingComponent, {
      model: widget
    }) : react_1.default.createElement(material_1.Typography, {
      variant: "h6",
      color: "inherit"
    }, heading), react_1.default.createElement(material_1.IconButton, {
      "data-testid": "".concat(widget.type, "-drawer-delete"),
      color: "inherit",
      "aria-label": "Delete",
      onClick: function onClick() {
        return session.hideWidget(widget);
      }
    }, react_1.default.createElement(Delete_1.default, null)));
  }))), react_1.default.createElement("div", {
    className: classes.spacer
  }), react_1.default.createElement("div", null, react_1.default.createElement(material_1.IconButton, {
    "data-testid": "drawer-close",
    color: "inherit",
    onClick: function onClick(event) {
      return setAnchorEl(event.currentTarget);
    }
  }, react_1.default.createElement(MoreVert_1.default, null)), react_1.default.createElement(material_1.Tooltip, {
    title: "Minimize drawer"
  }, react_1.default.createElement(material_1.IconButton, {
    "data-testid": "drawer-minimize",
    color: "inherit",
    onClick: function onClick() {
      session.notify("Drawer minimized, click button on ".concat(drawerPosition, " side of screen to re-open"), 'info');
      session.minimizeWidgetDrawer();
    }
  }, react_1.default.createElement(Minimize_1.default, null))), react_1.default.createElement(material_1.Tooltip, {
    title: "Close drawer"
  }, react_1.default.createElement(material_1.IconButton, {
    "data-testid": "drawer-close",
    color: "inherit",
    onClick: function onClick() {
      return session.hideWidget(visibleWidget);
    }
  }, react_1.default.createElement(Close_1.default, null))))), react_1.default.createElement(material_1.Menu, {
    anchorEl: anchorEl,
    open: Boolean(anchorEl),
    onClose: function onClose() {
      return setAnchorEl(null);
    }
  }, ['left', 'right'].map(function (option) {
    return react_1.default.createElement(material_1.MenuItem, {
      key: option,
      selected: drawerPosition === 'option',
      onClick: function onClick() {
        session.setDrawerPosition(option);
        setAnchorEl(null);
      }
    }, option);
  })));
});
var DrawerWidget = (0, mobx_react_1.observer)(function (_ref6) {
  var session = _ref6.session;
  var visibleWidget = session.visibleWidget;
  var _ref7 = (0, util_1.getEnv)(session),
    pluginManager = _ref7.pluginManager;
  var DrawerComponent = visibleWidget ? pluginManager.evaluateExtensionPoint('Core-replaceWidget', pluginManager.getWidgetType(visibleWidget.type).ReactComponent, {
    session: session,
    model: visibleWidget
  }) : null;
  // we track the toolbar height because components that use virtualized
  // height want to be able to fill the contained, minus the toolbar height
  // (the position static/sticky is included in AutoSizer estimates)
  var _ref8 = (0, react_1.useState)(0),
    _ref9 = _slicedToArray(_ref8, 2),
    toolbarHeight = _ref9[0],
    setToolbarHeight = _ref9[1];
  return react_1.default.createElement(Drawer_1.default, {
    session: session
  }, react_1.default.createElement(DrawerHeader, {
    session: session,
    setToolbarHeight: setToolbarHeight
  }), react_1.default.createElement(react_1.Suspense, {
    fallback: react_1.default.createElement(LoadingEllipses_1.default, null)
  }, react_1.default.createElement(react_error_boundary_1.ErrorBoundary, {
    FallbackComponent: function FallbackComponent(_ref10) {
      var error = _ref10.error;
      return react_1.default.createElement(ErrorMessage_1.default, {
        error: error
      });
    }
  }, DrawerComponent ? react_1.default.createElement(DrawerComponent, {
    model: visibleWidget,
    session: session,
    toolbarHeight: toolbarHeight
  }) : null)));
});
exports.default = DrawerWidget;